import React, { Fragment, useEffect } from "react";

import ListItem from "../../ListItem/ListItem";
import { ProductLinksMenu } from "../../../data/contentUnitMenu";
import { supplierContentMenu } from "../../../data/supplierContentMenu";
import BreadCrumb from "../../BreadCrumb/BreadCrumb";

function ProductMenu({ supplier }) {
  return (
    <Fragment>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        href1="/dashboard/content-controller"
      />
      <ListItem
        items={supplier ? supplierContentMenu : ProductLinksMenu}
        width="350px"
      />
    </Fragment>
  );
}

export default ProductMenu;
